module.exports = __webpack_public_path__ + "static/img/4-Oxford-University-partnership.5470f3f3.jpg";